import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2023/6B/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2023/6B/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2023/6B/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2023/6B/4.jpg';
// import p5 from 'assests/Photos/ClassAssembly/2023/7C/5.jpg';
// import p7 from 'assests/Photos/ClassAssembly/6D/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import SidebarArticles from 'views/ClassAssembly2023';

const ClassAssembly6B2023 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_archive_url: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/class-assembly/6B/1.webp`;
const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/class-assembly/6B/2.webp`;
const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/class-assembly/6B/3.webp`;
const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/class-assembly/6B/4.webp`;


  const photos = [
    {
      src: p2,
      source:p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
          src: p1,
          source: p1,
          rows: 1,
          cols: 2,
        },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 2,
    },
//     {
//         src: p5,
//         source: p5,
//         rows: 2,
//         cols: 2,
//       },
     
    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      Martyrs' Day 
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/>
 Class: 6B     Date: 29-31 JANUARY 2024

        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “Martyrs wrote their history with drops of courage and sacrifice.”
        </Typography>
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The Martyrs' Day Assembly curated by Class 6B from 29 January24 to 31 January24, resonated with a heartfelt tribute to freedom fighters becoming a transformative journey through the annals of sacrifice and valour. 

       <br></br>
        The impactful skit illuminated the challenges faced by soldiers, emphasizing sacrifice and unity. The skit was followed by a mesmerizing dance performance. The graceful movements of the students symbolised deep love for their country. 
        <br></br>
        The quiz session enriched students` knowledge about the freedom fighters, and served as a platform to recollect the stories of heroism and sacrifice. The assembly concluded with a reflective moment, successfully instilling a profound understanding of Martyrs' Day and renewed a sense of responsibility in preserving the invaluable legacy of those who sacrificed for our cherished freedom.
        
        </Typography>
      </Box>
      {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “A LITTLE EFFORT IS BETTER THAN NO EFFORT”

<br/>
        </Typography> */}

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <SidebarArticles />
             </Box>
          
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default ClassAssembly6B2023;